import React from "react";
import Skeleton from "@/app/_partials/_skeleton/Skeleton";

export default function ConvertSkeleton() {
    return (
        <div className="">
            <Skeleton height={405} borderRadius={16} />
            <Skeleton height={405} borderRadius={16} />            
        </div>
    );
}
